module.exports = __webpack_public_path__ + "img/dis02.22945b29.png";